import type { ReactElement } from 'react';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { sendEvent } from './analytics-client';

export const PostHogPageTracker = (): ReactElement | null => {
  const location = useLocation();

  useEffect(() => {
    // $pageview is a PostHog-reserved event name that powers built-in path
    // analysis — it must be sent as-is rather than through trackEvent.
    sendEvent('$pageview', { $current_url: window.location.href });
  }, [location.pathname]);

  return null;
};
